import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import './Header.scss';

const Header = () => {
    return (
      <div className="navBar">
        <Container>
          <Navbar expand="md">
            <Navbar.Brand className="page-name" href="/home">
             Portfolio
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                <Nav.Link className="header-link" href="/home">
                  Home
                </Nav.Link>
                <Nav.Link className="header-link" href="#about">
                  About
                </Nav.Link>
                <Nav.Link className="header-link" href="#contact">
                  Contact
                </Nav.Link>
                <Nav.Link className="header-link" href="#service">
                  Service
                </Nav.Link>
                <Nav.Link className="header-link" href="#projects">
                  Project
                </Nav.Link>
                <Nav.Link className="header-link" href="#blog">
                  Blog
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </div>
    );
};

export default Header;